import { render } from "./PartnersSidebar.vue?vue&type=template&id=1fdd5de0&scoped=true"
import script from "./PartnersSidebar.vue?vue&type=script&lang=js"
export * from "./PartnersSidebar.vue?vue&type=script&lang=js"

import "./PartnersSidebar.vue?vue&type=style&index=0&id=1fdd5de0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdd5de0"]])

export default __exports__